module.exports = __webpack_public_path__ + "static/assets/93cc1e28d25cf5653ad226beaac299d6.png";